import React from "react";

const UsersLightIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.78167 17.25H11.2183C11.7828 17.25 12.227 16.7817 12.1145 16.2285C11.804 14.7012 10.7897 12 7.49999 12C4.2103 12 3.19604 14.7012 2.88548 16.2285C2.77299 16.7817 3.21717 17.25 3.78167 17.25Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.75 12C15.8288 12 16.6802 14.1479 17.0239 15.696C17.2095 16.532 16.5333 17.25 15.6769 17.25H14.75",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 8.25C9.01878 8.25 10.25 7.01878 10.25 5.5C10.25 3.98122 9.01878 2.75 7.5 2.75C5.98122 2.75 4.75 3.98122 4.75 5.5C4.75 7.01878 5.98122 8.25 7.5 8.25Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.75 8.25C14.2688 8.25 15.25 7.01878 15.25 5.5C15.25 3.98122 14.2688 2.75 12.75 2.75",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(UsersLightIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;